import { Engine } from "@babylonjs/core/Engines/engine";
import { Texture as BJSTexture } from "@babylonjs/core/Materials/Textures/texture";
import { Matrix } from "@babylonjs/core/Maths/math.vector";
import { SerializationHelper } from "@babylonjs/core/Misc/decorators";
export class Texture extends BJSTexture {
    get isClone() {
        return (this.mIsClone);
    }
    //url: Nullable<string>, scene: Nullable<Scene>, noMipmap?: boolean, invertY?: boolean, samplingMode?: number, onLoad?: Nullable<() => void>, onError?: Nullable<(message?: string, esception?: any) => void>, buffer?: Nullable<string | ArrayBuffer | HTMLImageElement | Blob>, deleteBuffer?: boolean, format?: number
    constructor(pUrl, pScene, pOnLoad, pOnError, pSamplingMode = BJSTexture.TRILINEAR_SAMPLINGMODE, pFormat = Engine.TEXTUREFORMAT_RGB) {
        super(pUrl, pScene, false, true, pSamplingMode, pOnLoad, pOnError, null, false, pFormat);
        this.mTextureMatrix = null;
        this.mIsClone = false;
        this.isResource = false;
        this.isFallback = false;
        this.id = "";
    }
    notifyTextureMatrixChanged() {
        this.mTextureMatrix = null;
    }
    getTextureMatrix() {
        if (this.mTextureMatrix == null) {
            //we use a custom texture matrix, babylonJS applies rotation, scale and offset in a different order
            const tScaleMat = Matrix.Scaling(this.uScale, this.vScale, 1.0);
            const tRotMat = Matrix.RotationYawPitchRoll(this.vAng, this.uAng, this.wAng);
            //var tOffsetMat = Matrix.Translation(pTexture.uOffset, pTexture.vOffset, 0);
            const tOffsetMat = Matrix.Identity(); //use a 2d translation matrix
            tOffsetMat.setRowFromFloats(2, this.uOffset, this.vOffset, tOffsetMat.m[10], tOffsetMat.m[11]);
            const tMatrix = tScaleMat;
            tRotMat.multiplyToRef(tMatrix, tMatrix);
            tOffsetMat.multiplyToRef(tMatrix, tMatrix);
            this.mTextureMatrix = tMatrix;
        }
        return (this.mTextureMatrix);
    }
    clone() {
        const tClone = SerializationHelper.Clone(() => {
            return (new Texture(this.url, this.getScene(), undefined, undefined, this.samplingMode, this._format == null ? Engine.TEXTUREFORMAT_RGB : this._format));
        }, this);
        tClone.mIsClone = true;
        tClone.isResource = this.isResource;
        tClone.isFallback = this.isFallback;
        tClone.id = this.id;
        return (tClone);
    }
    /*** internal *****************************************************************************/
    /** @internal */
    static _DisposeIfCloned(pTexture) {
        if (pTexture == null)
            return;
        if (pTexture instanceof Texture && pTexture.isClone)
            pTexture.dispose();
    }
}
